import React, { useEffect } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Router from '../router/Router';
import {
  createMuiTheme,
  Theme,
  ThemeProvider,
} from '@material-ui/core/styles';
import { store } from '../../redux/store';
import { Provider } from 'react-redux';
import browserHistory from '../../utils/browserHistory';
import {
  AuthRoutes,
  ModulesKeys,
  stationDashboardUrlId,
} from '../../interfaces/routes';
import * as Sentry from '@sentry/react';
import EphemeralStateService from '../../services/EphemeralState.service';

import './App.css';
import LocalStorageService from '../../services/LocalStorage.service';

const MAIN_COLOR = '#444444';

const theme: Theme = createMuiTheme({
  palette: {
    primary: {
      dark: MAIN_COLOR,
      light: MAIN_COLOR,
      main: MAIN_COLOR,
    },
  },
});

const App: React.FC = () => {
  const updateUrl = () => {
    // Construct URLSearchParams object instance from current URL querystring.
    const queryParams = new URLSearchParams(window.location.search);

    // Set new or modify existing parameter value.
    queryParams.set(
      stationDashboardUrlId,
      EphemeralStateService.getMyStationId().toString(),
    );

    // Replace current querystring with the new one.

    window.history.replaceState(
      null,
      '',
      '?' + queryParams.toString(),
    );
  };

  useEffect(() => {
    browserHistory.listen((location, action) => {
      // Only add station id url param on module urls, and only for PUSH action
      if (
        ['PUSH'].includes(action) &&
        Object.keys(ModulesKeys)
          .map((key) => {
            return AuthRoutes[key as ModulesKeys];
          })
          .some((key) => window.location.pathname.includes(key))
      ) {
        updateUrl();
      }

      // Update last hit time
      if (['PUSH'].includes(action)) {
        LocalStorageService.setLastHitDate();
      }
    });

    // Set last hit time when the app first loads
    LocalStorageService.setLastHitDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router />
      </ThemeProvider>
    </Provider>
  );
};

export default Sentry.withProfiler(App);
